module.exports = __webpack_public_path__ + "img/controler_visiteur_update.8efa3e4a.png";